import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DsStatusBadge } from './status-badge/status-badge';
import { DsEmptyState } from './empty-state/empty-state';
import { DsPageHeader } from './page-header/page-header';
import { DsFilterBar } from './filter-bar/filter-bar';
import { DsPagination } from './pagination/pagination';
import { DsDataTable } from './data-table/data-table';

const DESIGN_SYSTEM_COMPONENTS = [
  DsStatusBadge,
  DsEmptyState,
  DsPageHeader,
  DsFilterBar,
  DsPagination,
  DsDataTable,
];

@NgModule({
  declarations: DESIGN_SYSTEM_COMPONENTS,
  imports: [CommonModule],
  exports: DESIGN_SYSTEM_COMPONENTS,
})
export class DesignSystemModule {}
